import React from "react";
import { SymbolComponentType } from "../helpers/getSymbol";

const DMETACAN = (props: SymbolComponentType) => {
  const { index, attributes, transformStr } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 10.433885 9.3975584"
      key={index}
      id={`symbol-${index}`}
      tabIndex={0}
      className="symbol target"
      name="symbol"
      preserveAspectRatio="xMidYMid meet"
      style={{
        top: `${attributes.top}%`,
        left: `${attributes.left}%`,
        width: `${attributes.width}%`,
        height: `${attributes.height}%`,
        zIndex: attributes.zIndex,
        // transform:`rotate(${attributes?.transform?.rotate}deg) scaleX(${attributes?.transform?.scaleX}) scaleY(${attributes?.transform?.scaleY}) matrix3d(${attributes?.transform?.matrix3d})`
        transform: transformStr,
      }}
    >
      <path
        stroke={`${attributes.borderColor || "white"}`}
        fill={`${attributes?.backgroundColor || "transparent"}`}
        strokeWidth={`${attributes.lineWidth || 0.1}`}
        // className="dme_tacan"
        d="M 3.63,8.91 V 6.31 L 2.22,3.99 0.33,2.76 1.64,0.35 3.68,1.57 H 6.49 L 8.53,0.35 9.84,2.76 7.95,3.99 6.54,6.31 v 2.6 z"
      />
    </svg>
  );
};

export default DMETACAN;
